import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { AlertTriangle } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const OOOModal = ({ open, onClose, room, propertyId, onSuccess }) => {
  const [formData, setFormData] = useState({
    maintenance_note: '',
    maintenance_start: new Date().toISOString().slice(0, 16),
    maintenance_end: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.maintenance_note.trim()) {
      toast.error('Please provide a reason for marking room out of order');
      return;
    }

    try {
      const token = localStorage.getItem('access_token');
      await axios.patch(
        `${API}/properties/${propertyId}/units/${room.id}`,
        {
          status: 'OOO',
          maintenance_status: 'OOO',
          maintenance_note: formData.maintenance_note,
          maintenance_start: formData.maintenance_start || new Date().toISOString(),
          maintenance_end: formData.maintenance_end || null
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      toast.success(`Room ${room.name} marked Out of Order`);
      if (onSuccess) onSuccess();
      onClose();
    } catch (error) {
      toast.error('Failed to update room status');
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="text-orange-600" size={20} />
            Put Room {room?.name} Out of Order
          </DialogTitle>
        </DialogHeader>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label>Reason / Issue *</Label>
            <textarea
              value={formData.maintenance_note}
              onChange={(e) => setFormData({...formData, maintenance_note: e.target.value})}
              className="w-full px-3 py-2 border border-slate-300 rounded-md min-h-[100px]"
              placeholder="e.g., Plumbing issue, AC not working, deep cleaning..."
              required
            />
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label>Start Date/Time</Label>
              <Input
                type="datetime-local"
                value={formData.maintenance_start}
                onChange={(e) => setFormData({...formData, maintenance_start: e.target.value})}
              />
            </div>
            <div>
              <Label>Expected Return (optional)</Label>
              <Input
                type="datetime-local"
                value={formData.maintenance_end}
                onChange={(e) => setFormData({...formData, maintenance_end: e.target.value})}
              />
            </div>
          </div>

          <div className="bg-orange-50 border border-orange-200 rounded-lg p-3 text-sm">
            <p className="text-orange-900">
              This room will be unavailable for new reservations until returned to service.
            </p>
          </div>

          <div className="flex gap-2">
            <Button type="submit" className="flex-1 bg-orange-600 hover:bg-orange-700">
              Mark Out of Order
            </Button>
            <Button type="button" variant="outline" onClick={onClose}>
              Cancel
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default OOOModal;
